import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import 'react-id-swiper/lib/styles/css/swiper.css';

import { getSubscription, getFlashMessage, getPixSessionToken } from '../store/selectors';
import { Title, Subtitle } from '../components/Title';
import CardForm from '../components/CardForm';
import { swiperParams, DefaultWrapper } from '../lib/global-styles';
import { getCardFlagImage } from '../lib/flagResolver';
import Header from '../components/Header';
import PixPayment from '../components/PixPayment.js';
import {
  ProductItem,
  ProductItemWrapper,
  ProductInfo,
  ProductPrice,
  ProductItemFooter,
  ListChanelsButton,
  PaymentMethod,
  PaymentInfo,
  Separator,
  CardInfo,
  ActionLink,
  DigitalSubscription,
  SubscriptionInfoBody,
  CardEditWrapper,
} from '../components/Products/ProductsComponents';
import { currencyFilter, validateCardForm } from '../lib/utils';
import Modal from '../components/Modal/Modal';
import { doShowModal, doRequestUpdateCard } from '../store/actions';
import { Button } from '../components/Button';
import FlashMessage from '../components/FlashMessage';
import { postMessageSender } from '../lib/postMessager';

class SubscriptionInfo extends Component {
  state = {
    swiperParams: { ...swiperParams },
    newCard: {
      cvv: '',
      number: '',
      validity: '',
    },
    error: {
      number: '',
      validity: '',
      cvv: '',
    },
  };

  onCardClick = e => {
    e.preventDefault();
    const { target } = e.target.dataset;

    this.props.onShowModal(target);

    postMessageSender({
      scrollTop: true,
    });
  };

  onClickCardEdit = () => {
    const { newCard } = this.state;
    const { validated, error } = validateCardForm(newCard);

    if (validated) {
      this.props.onRequestUpdateCard(newCard);
    } else {
      this.setState({ error });
    }
  };

  onChangeInput = e => {
    const { name, value } = e.target;
    const { newCard } = this.state;
    const updatedCard = { ...newCard, [name]: value };

    this.setState({ newCard: updatedCard });
  };

  onProductClick = () => {
    this.props.history.push('editar-produto');
  };

  getDigitalSubscriptionInfoBasedOnProduct = nome_fantasia_raw => {
    const skeelo = 'https://skycms.s3.amazonaws.com/images/34232075/skeelo.png';
    const playkids = 'https://skycms.s3.amazonaws.com/images/34232075/playkids.png';
    const mcafee = 'https://skycms.s3.amazonaws.com/images/34232075/mcafee.png';
    const height = '65';
    const nome_fantasia = nome_fantasia_raw.toLowerCase();

    return nome_fantasia.includes('digital') ? (
      <img src={skeelo} height={height} alt="mcafee" />
    ) : (
      <>
        <img src={mcafee} height={height} alt="mcafee" />
        <img src={playkids} height={height} alt="playkids" />
        <img src={skeelo} height={height} alt="skeelo" />
      </>
    );
  };

  getDigitalSubscriptionText = nome_fantasia_raw => {
    const nome_fantasia = nome_fantasia_raw.toLowerCase();
    return nome_fantasia.includes('digital')
      ? 'Você tem direito ao Skeelo Light'
      : nome_fantasia.includes('smart')
      ? 'Você tem direito às versões light do Skeelo, PlayKids e McAfee'
      : 'Você tem direito às versões Premium do Skeelo, PlayKids e McAfee';
  };

  getPaymentInfoDivClass = () => {
    return this.props.subscription.pagamento.status === 'SUCESSO' ? 'success' : 'error';
  };

  getPaymentInfoTitle = () => {
    if (this.props.subscription.pagamento.status === 'SUCESSO') {
      return 'Pagamento Realizado';
    } else {
      return 'Pagamento Pendente';
    }
  };

  getPaymentInfoText = () => {
    const status = this.props.subscription.pagamento.status
    const tipoPagamento = this.props.subscription.pagamento.tipoPagamento
    if (status === 'SUCESSO' && tipoPagamento === 'CARTAO_CREDITO') {
      return (
        'Você realizou seu último pagamento do seu plano Sky via cartão ' +
        this.props.subscription.cartao.bandeira +
        ' final  ' +
        this.props.subscription.cartao.ultimosDigitos
      );
    }
    else if (status === 'SUCESSO' && tipoPagamento === 'PIX') {
      return (
        'Você realizou seu último pagamento do plano Sky TV via PIX. As próximas contas continuarão sendo cobradas no seu cartão ' +
        this.props.subscription.cartao.bandeira +
        ' final  ' +
        this.props.subscription.cartao.ultimosDigitos
      );
    } else if (status === 'FALHA') {
      return (
        'Não conseguimos efetuar o pagamento do seu plano Sky TV no cartão ' +
        this.props.subscription.cartao.bandeira +
        ' final ' +
        this.props.subscription.cartao.ultimosDigitos
      );
    }
  };

  render() {
    const { subscription, flashMessage, pixSessionToken } = this.props;
    const { swiperParams, newCard, error } = this.state;

    return (
      <>
        <Header secondary />
        <SubscriptionInfoBody>
          <DefaultWrapper>
            <Title>Dados Cadastrais</Title>
            <Subtitle>O que você tem hoje:</Subtitle>
            <ProductItem color="pink">
              <ProductItemWrapper>
                <ProductInfo twoColumns>
                  <div>
                    <h3>
                      {subscription.produto.nome_fantasia}
                      {subscription.produto.isCombo ? ` + ${subscription.produto.nomeCombo}` : ''}
                      {' Recorrente'}
                    </h3>
                  </div>
                  <div>
                    <ProductPrice secondary>
                      {currencyFilter(subscription.produto.valor)}/mês
                    </ProductPrice>
                    <p>Renova todo dia {subscription.data_proxima_recarga.split('-').pop()}</p>
                  </div>
                </ProductInfo>
                <ProductItemFooter>
                  <ListChanelsButton>
                    {subscription.produto.quantidade_canais} canais
                  </ListChanelsButton>
                  <ActionLink onClick={this.onProductClick}>Quero trocar</ActionLink>
                </ProductItemFooter>
              </ProductItemWrapper>
              <Swiper {...swiperParams}>
                {subscription.produto.imagens.map((image, key) => (
                  <img key={key} alt="canais" src={image} />
                ))}
              </Swiper>
            </ProductItem>
            <Title>Forma de Pagamento</Title>
            <PaymentMethod pix={pixSessionToken ? 'true' : 'false'}>
              <PaymentInfo>
                <div className={this.getPaymentInfoDivClass()}>
                  <div className="header">
                    <div className="icon" />
                    <div className="title">{this.getPaymentInfoTitle()}</div>
                  </div>
                  <div>{this.getPaymentInfoText()}</div>
                </div>
              </PaymentInfo>
              <Separator />
              <CardInfo>
                <div className="title">Cartão de Crédito</div>
                <div className="item">
                  <div className="label">Bandeira</div>
                  <div className="cardflag">
                    <img
                      src={getCardFlagImage(subscription.cartao.bandeira.toLowerCase())}
                      alt={subscription.cartao.bandeira}
                      height="25"
                    />
                  </div>
                </div>
                <div className="item">
                  <p className="label">Final</p>
                  <p className="value">
                    <span>&#11044;&#11044;&#11044;&#11044;</span>
                    <span>&#11044;&#11044;&#11044;&#11044;</span>
                    <span>&#11044;&#11044;&#11044;&#11044;</span>
                    {subscription.cartao.ultimosDigitos}
                  </p>
                </div>
                <div className="filler" />
                <Button
                  onClick={this.onCardClick}
                  data-target="card-edit"
                  type="submit"
                  theme={{ style: 'dark' }}
                >
                  Trocar Cartão
                </Button>
              </CardInfo>
              {pixSessionToken && <PixPayment />}
            </PaymentMethod>
            <Subtitle>Assinaturas digitais</Subtitle>
            <DigitalSubscription>
              <div>
                {this.getDigitalSubscriptionInfoBasedOnProduct(subscription.produto.nome_fantasia)}
              </div>
              <p>{this.getDigitalSubscriptionText(subscription.produto.nome_fantasia)}</p>
              <a
                href="https://sky.com.br/sky-pre-pago/assinaturas-digitais"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mostrar mais
              </a>
            </DigitalSubscription>
            <Modal target="card-edit" targetClass="card-edit-modal">
              {flashMessage.type ? (
                <FlashMessage hideReturnButton />
              ) : (
                <CardEditWrapper>
                  <Title>Editar Cartão</Title>
                  <CardForm onChangeInput={this.onChangeInput} card={newCard} error={error} filled>
                    <Button onClick={this.onClickCardEdit} type="submit" dark noBorder>
                      Confirmar
                    </Button>
                  </CardForm>
                </CardEditWrapper>
              )}
            </Modal>
          </DefaultWrapper>
        </SubscriptionInfoBody>
      </>
    );
  }
}

SubscriptionInfo.propTypes = {
  subscription: PropTypes.object.isRequired,
  flashMessage: PropTypes.object.isRequired,
  onShowModal: PropTypes.func.isRequired,
  onRequestUpdateCard: PropTypes.func.isRequired,
};

SubscriptionInfo.defaultProps = {
  pixSessionToken: undefined,
};

const mapStateToProps = state => ({
  subscription: getSubscription(state),
  flashMessage: getFlashMessage(state),
  pixSessionToken: getPixSessionToken(state),
});

const mapDispatchToProps = dispatch => ({
  onShowModal: target => dispatch(doShowModal(target)),
  onRequestUpdateCard: card => dispatch(doRequestUpdateCard(card)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubscriptionInfo);
